

import AdminApp from "./admin/AdminApp";

function App() {
  return <AdminApp />;
}

export default App;
